import { parseIncomeYen } from '../spouseSection/spouseEligibility';
import type {
  RetirementAllowanceEntry,
  RetirementAllowanceSnapshot,
  RetirementRecipientCategory,
  YesNo,
} from './retirementAllowanceTypes';
import { emptyRetirementAllowanceSnapshot } from './retirementAllowanceTypes';

export type RetirementAllowanceApi = {
  anyExpected?: boolean | null;
  recipientCategory?: string | null;
  entries?: Array<{
    id?: number | null;
    empFamilyId?: number | null;
    memberFullName?: string | null;
    memberRelationship?: string | null;
    retirementAllowanceAmount?: number | string | null;
  }> | null;
};

function boolToYn(v: boolean | null | undefined): YesNo | '' {
  if (v === true) return 'yes';
  if (v === false) return 'no';
  return '';
}

function ynToBool(v: YesNo | ''): boolean | undefined {
  if (v === 'yes') return true;
  if (v === 'no') return false;
  return undefined;
}

function amountFromApi(v: number | string | null | undefined): string {
  if (v == null || v === '') return '';
  if (typeof v === 'number') return String(Math.trunc(v));
  return v.trim().replace(/,/g, '');
}

export function retirementAllowanceFromApi(
  raw: RetirementAllowanceApi | null | undefined
): RetirementAllowanceSnapshot {
  if (!raw) return emptyRetirementAllowanceSnapshot();
  const entries: RetirementAllowanceEntry[] = (raw.entries ?? []).map((e) => ({
    empFamilyId: e.empFamilyId ?? 0,
    memberFullName: e.memberFullName?.trim() ?? '',
    memberRelationship: e.memberRelationship?.trim() ?? '',
    retirementAllowanceAmount: amountFromApi(e.retirementAllowanceAmount),
  }));
  const cat = (raw.recipientCategory?.trim() ?? '') as RetirementRecipientCategory | '';
  return {
    anyExpected: boolToYn(raw.anyExpected),
    recipientCategory: cat === 'spouse' || cat === 'dependents' ? cat : '',
    entries,
  };
}

export function retirementAllowanceToApi(snap: RetirementAllowanceSnapshot): RetirementAllowanceApi {
  return {
    anyExpected: snap.anyExpected === '' ? null : ynToBool(snap.anyExpected),
    recipientCategory: snap.recipientCategory === '' ? null : snap.recipientCategory || undefined,
    entries: snap.entries.map((e) => {
      const amount = parseIncomeYen(e.retirementAllowanceAmount);
      return {
        empFamilyId: e.empFamilyId,
        memberFullName: e.memberFullName || undefined,
        memberRelationship: e.memberRelationship || undefined,
        retirementAllowanceAmount: amount > 0 ? amount : undefined,
      };
    }),
  };
}
